import React, { Component } from "react";
import FadeIn from "react-fade-in/lib/FadeIn";
import {
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  TabsCustom,
  TabsCustomHeader,
  TabsCustomMenu,
  TabsCustomBody,
  TabsCustomItem,
} from "ui-kit-ck-consultant";

import { getReparableLabelsList } from "./TableReparable";
import { getUnreparableLabelsList } from "./TableUnreparable";
import { formatStat } from "./statFormat";

const toNumber = (value) => {
  if (value == null || value === "") return null;
  if (typeof value === "number") return isNaN(value) ? null : value;
  const cleaned = String(value)
    .replace(/ /g, "")
    .replace(/\s/g, "")
    .replace(/[^\d.,-]/g, "")
    .replace(",", ".");
  if (cleaned === "" || cleaned === "-") return null;
  const n = parseFloat(cleaned);
  return isNaN(n) ? null : n;
};

const compareValues = (a, b) => {
  const aNull = a == null || a === "";
  const bNull = b == null || b === "";
  if (aNull && bNull) return 0;
  if (aNull) return 1;
  if (bNull) return -1;
  const aNum = toNumber(a);
  const bNum = toNumber(b);
  if (aNum != null && bNum != null) return aNum - bNum;
  return String(a).localeCompare(String(b), "fr", { sensitivity: "base" });
};

const SortIndicator = ({ direction }) => (
  <span style={{ marginLeft: 4, fontSize: 10, opacity: direction ? 1 : 0.3 }}>
    {direction === "desc" ? "▼" : "▲"}
  </span>
);

export default class TableByExpert extends Component {
  state = {
    mode: "R",
    sort: { R: null, NR: null },
  };

  handleSort = (datasetKey, key) => {
    this.setState((prev) => {
      const current = prev.sort[datasetKey];
      let next;
      if (!current || current.key !== key) {
        next = { key, direction: "asc" };
      } else if (current.direction === "asc") {
        next = { key, direction: "desc" };
      } else {
        next = null;
      }
      return { sort: { ...prev.sort, [datasetKey]: next } };
    });
  };

  getSortValue = (expert, datasetKey, key) => {
    if (key === "__expert") return expert.name;
    if (key === "__agency") return expert.agencyName;
    const row =
      expert.dataGeneral &&
      expert.dataGeneral[datasetKey] &&
      expert.dataGeneral[datasetKey][1];
    return row ? row[key] : null;
  };

  renderTable(labels, datasetKey) {
    const experts = (this.props.data || []).filter((expert) => {
      const row =
        expert.dataGeneral &&
        expert.dataGeneral[datasetKey] &&
        expert.dataGeneral[datasetKey][1];
      return row && Number(row.nbFolders) > 0;
    });

    const sort = this.state.sort[datasetKey];
    const sorted = sort
      ? [...experts].sort((a, b) => {
          const av = this.getSortValue(a, datasetKey, sort.key);
          const bv = this.getSortValue(b, datasetKey, sort.key);
          const cmp = compareValues(av, bv);
          return sort.direction === "desc" ? -cmp : cmp;
        })
      : experts;

    const headerStyle = { cursor: "pointer", userSelect: "none" };
    const dirFor = (key) => (sort && sort.key === key ? sort.direction : null);

    return (
      <FadeIn className={"overflow-x-auto"}>
        <Table>
          <Thead>
            <Tr>
              <Th
                style={headerStyle}
                onClick={() => this.handleSort(datasetKey, "__expert")}
              >
                Expert
                <SortIndicator direction={dirFor("__expert")} />
              </Th>
              <Th
                style={headerStyle}
                onClick={() => this.handleSort(datasetKey, "__agency")}
              >
                Agence
                <SortIndicator direction={dirFor("__agency")} />
              </Th>
              {labels.map((label) => (
                <Th
                  key={label.id}
                  style={headerStyle}
                  onClick={() => this.handleSort(datasetKey, label.id)}
                >
                  {label.name}
                  <SortIndicator direction={dirFor(label.id)} />
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {sorted.map((expert) => {
              const row =
                expert.dataGeneral &&
                expert.dataGeneral[datasetKey] &&
                expert.dataGeneral[datasetKey][1]
                  ? expert.dataGeneral[datasetKey][1]
                  : {};
              return (
                <Tr key={expert.id}>
                  <Th>{expert.name}</Th>
                  <Td>{expert.agencyName}</Td>
                  {labels.map((label) => (
                    <Td key={label.id}>
                      {row[label.id] != null
                        ? formatStat(row[label.id], label.isCount)
                        : ""}
                    </Td>
                  ))}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </FadeIn>
    );
  }

  render() {
    const reparableLabels = getReparableLabelsList();
    const unreparableLabels = getUnreparableLabelsList();
    return (
      <TabsCustom>
        <TabsCustomHeader noCard>
          <TabsCustomMenu
            noCard
            title="Réparables"
            active={this.state.mode === "R"}
            onClick={() => this.setState({ mode: "R" })}
          />
          <TabsCustomMenu
            noCard
            title="Non Réparables"
            active={this.state.mode === "NR"}
            onClick={() => this.setState({ mode: "NR" })}
          />
        </TabsCustomHeader>
        <TabsCustomBody noCard>
          <TabsCustomItem active={this.state.mode === "R"}>
            {this.renderTable(reparableLabels, "R")}
          </TabsCustomItem>
          <TabsCustomItem active={this.state.mode === "NR"}>
            {this.renderTable(unreparableLabels, "NR")}
          </TabsCustomItem>
        </TabsCustomBody>
      </TabsCustom>
    );
  }
}
